<!-- Alert -->
<fuse-alert
    class="mt-8 top-0 right-0 absolute z-99"
    *ngIf="showAlert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
</fuse-alert>

<div class="flex flex-col w-full p-2 md:p-8">
    <div class="flex flex-col">
        <div class="text-primary text-3xl font-extrabold">
            Confirm your delivery and installation details
        </div>

        <hr class="my-5">
    </div>

    <div class="flex flex-row w-full items-center justify-center">
        <mat-stepper labelPosition="bottom" class="w-full" #stepper  [orientation]="(isDesktop ? 'horizontal' : 'vertical')"  (animationDone)="scrollToTop()">
            <mat-step #stepOne label="Your details" [editable]="'false'">
                <app-confirm-details (confirmDetailsEvent)="confirmDetails($event)" [lead]="lead"></app-confirm-details>

                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <button
                        (click)="goToCart()"
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                         >
                            Cancel
                    </button>
                    <button
                        [disabled]="!confirmDetailsValid"
                        (click)="updateLead('delivery_details_entity')"
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        matStepperNext>
                            Continue
                    </button>
                </div>
            </mat-step>
            <mat-step label="Order details" [editable]="'false'">
                <app-order-details [lead]="lead" (confirmOrderEvent)="confirmOrder($event)"></app-order-details>

                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <button
                        (click)="goToCart()"
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                         >
                            Cancel
                    </button>
                    <button
                        [disabled]="!confirmOrderValid"
                        (click)="updateLead('delivery_details_address')"
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        matStepperNext>
                            Continue
                    </button>
                </div>

            </mat-step>
            <mat-step label="Summary" [editable]="'false'">

                <app-summary (acceptedTerms)="termsCheckedValue($event)" [lead]="lead" [center]="center" [order]="order" [addOns]="addOns" [upFrontAmount]="upFrontAmount" [monthlyAmount]="monthlyAmount" [VAT]="VAT"></app-summary>

                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <button
                        (click)="goToCart()"
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                         >
                            Cancel
                    </button>
                    <button
                        (click)="gtmTagging('confirm_order')"
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        [disabled]="!allTermsAccepted"
                        mat-button
                        matStepperNext>
                            Confirm order
                    </button>
                </div>
            </mat-step>
            <mat-step label="Payment" [editable]="'false'">
                <app-payment 
                    [lead]="lead"
                    [monthlyAmount]="monthlyAmount"
                    [upFrontAmount]="upFrontAmount"
                    (hasPaymentMethod)="hasPaymentMethodEvent($event)"
                    (acceptedTerms)="termsCheckedValue($event)"
                    (detailsChecked)="confirmDetailsValue($event)"
                    (hasDebitOrderBeenSigned)="confirmDebitOrderSignedValue($event)"
                ></app-payment>
                <div class="flex flex-row justify-end mt-6">
                    <button
                        (click)="goToCart()"
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                         >
                            Cancel
                    </button>
                    <button
                        *ngIf="!placeOrderLoader"
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        matStepperNext
                        [disabled]="!hasPaymentMethod || !allTermsAccepted || !debitOrderWasSigned"
                        (click)="placeOrder()">
                            Place order
                    </button>
                    <button
                        *ngIf="placeOrderLoader"
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        matStepperNext
                        disabled>
                        <mat-spinner class="h-5 w-5 white"></mat-spinner>
                    </button>
                </div>
            </mat-step>
        </mat-stepper>

    </div>

</div>